import type { RpcFetchOptions } from "./../../interfaces/index.js";
import { fetchRpcDirect } from "./utils/index.js";
import { getLimiter } from "./../instance.js";
/**
 * Single public RPC entrypoint.
 * Switches transport without changing call sites.
 */
export async function fetchRpc<
  TResult,
  TParams extends readonly unknown[]
>(
  method: string,
  params: any,
  opts: RpcFetchOptions = {}
): Promise<TResult> {

  // Rule: limiter wins unless explicitly disabled
  if (opts.useLimiter !== false) {
    return await getLimiter().fetchRpc(method, params);
  }

  return fetchRpcDirect<TResult, TParams>(method, params, opts);
}
